import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import BSPagination from "../../Components/pagination";
import {
  deleteCityById,
  fetchCitiesList,
  restoreCity,
  searchCities,
  toggleCityStatus,
} from "../../services/axios/apiManager";
import CitiesFilters from "./citiesFilters";
import AddEditCityModal from "./addEditCityModal";
import CityDetailsModal from "./cityDetails";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const CitiesList = ({
  cities,
  countries,
  pagination,
  setCities,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState("3");
  const [filtering, setFiltering] = useState(false);
  const [selectedCity, setSelectedCity] = useState({});
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const tableRef = useRef(null);

  const columns = [{ data: "city_name", title: "City" }];

  // // // Fetch Cities list
  const fetchCities = async (pgntn, str = "") => {
    setFiltering(true);
    const res = await fetchCitiesList(pgntn.currentPage, pgntn.pageSize, str);
    if (res?.data?.data) {
      setCities(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate, "Cites List:");
    }
    setFiltering(false);
  };

  // // // Handle Page Change
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    if (query.length > 0) {
      setFiltering(true);
      setFilters("3");
      const res = await searchCities(query, temp?.currentPage, temp?.pageSize);
      if (res?.data?.data) {
        setCities(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate, "Cites List:");
      }
      setFiltering(false);
    } else {
      const str = `status=${filters}`;
      await fetchCities(temp, str);
    }
  };

  // // // Open Status change modal
  const handleStatusChange = async (cty) => {
    if (!granted?.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of City "${cty.city_name}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: cty.id, status: cty.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  // // // Change Status logic
  const changeStatus = async (data) => {
    const res = await toggleCityStatus(data);
    if (res?.data?.success === true) {
      const str = `status=${filters}`;
      await fetchCities(pagination, str);
    } else {
      handleErrors(res, navigate, "Change Status:");
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Delete Province Modal logic
  const deleteCityModal = (cty) => {
    // one
    setModalOptions({
      header: "Delete City",
      body: `Are you sure you want to delete City "${cty?.city_name || ""}"?`,
      okay: "Delete",
      method: deleteCity,
      data: { id: cty.id },
    });
    setShowOptionsModal(true);
  };

  // // // Delete Province logic
  const deleteCity = async (data) => {
    if (data.id) {
      const res = await deleteCityById(data.id);
      if (res?.data?.success) {
        const str = `status=${filters}`;
        await fetchCities(pagination, str);
        toast.info("City record has been deleted!", {
        duration: 2000,
      });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate, "Delete City:");
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // // Restore City Modal logic
  const restoreCityModal = (cty) => {
    // one
    setModalOptions({
      header: "Restore City",
      body: `Are you sure you want to restore City "${cty?.city_name || ""}"?`,
      okay: "Restore",
      method: restoreCityById,
      data: { id: cty.id },
    });
    setShowOptionsModal(true);
  };

  // // // Restore City logic
  const restoreCityById = async (data) => {
    if (data.id) {
      const res = await restoreCity(data.id);
      if (res?.data?.success) {
        const str = `status=${filters}`;
        await fetchCities(pagination, str);
        toast.info("City record has been restored!", {
        duration: 2000,
      });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate, "Delete City:");
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // // Open Details Modal
  const handleOpenDetailsModal = (cty) => {
    setSelectedCity(cty);
    setOpenDetailsModal(true);
  };

  // // // Close Status/Delete Modal logic
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Open Add Edit Modal
  const handleOpenAddEditModal = (cty) => {
    setSelectedCity(cty);
    setShowAddEditModal(true);
  };

  useEffect(() => {
    const tableData = cities.map((cit) => {
      const row = columns.map((col) => cit[col.data]);
      row.push(
        `<button class=\"btn btn-sm status-btn ${cit.status === 1 ? "text-success" : "text-danger"}\" data-id=\"${cit.id}\" title="change status">${cit.status === 1 ? "Active" : "Inactive"}</button>`
      );
      row.push(
        (filters !== "2"
          ? `<button class=\"btn btn-outline-info btn-sm view-btn me-1\" data-id=\"${cit.id}\" title="view details"><i class=\"fas fa-eye\"></i></button>`
          : "") +
          (granted?.some((g) => g.type === "update") && filters !== "2"
            ? `<button class=\"btn btn-outline-primary btn-sm edit-btn me-1\" data-id=\"${cit.id}\" title="edit"><i class=\"fas fa-edit\"></i></button>`
            : "") +
          (granted?.some((g) => g.type === "delete") &&
          !cit.is_associated &&
          filters !== "2" &&
          cit.status === 0
            ? `<button class=\"btn btn-outline-danger btn-sm delete-btn\" data-id=\"${cit.id}\" title="delete"><i class=\"fas fa-trash\"></i></button>`
            : "") +
          (filters === "2" && cit.status === 0
            ? `<button class=\"btn btn-outline-danger btn-sm restore-btn\" data-id=\"${cit.id}\" title="restore"><i class="fa-solid fa-rotate-right"></i></button>`
            : "")
      );
      return row;
    });
    const config = {
      data: tableData,
      columns: [
        { title: "Name", className: "text-start" },
        ...columns.slice(1).map((col) => ({ title: col.title })),
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],

      destroy: true,
      responsive: true,
      pageLength: pagination.pageSize || 10,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().rows.add(tableData).draw();
    } else {
      $(tableRef.current).DataTable(config);
    }
    const $table = $(tableRef.current);
    $table.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const city = cities.find((c) => c.id === id);
      handleOpenDetailsModal(city);
    });
    $table.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      const city = cities.find((c) => c.id === id);
      handleOpenAddEditModal(city);
    });
    $table.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const city = cities.find((c) => c.id === id);
      deleteCityModal(city);
    });
    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const city = cities.find((c) => c.id === id);
      if(city?.deletedAt===null){
        handleStatusChange(city);
      }else{
        toast.info("Cannot change status of a deleted record!", {
          duration: 2000,
        });
      }
    });
    $table
      .off("click", ".restore-btn")
      .on("click", ".restore-btn", function () {
        const id = $(this).data("id");
        const city = cities.find((c) => c.id === id);
        restoreCityModal(city);
      });

    return () => {
      $table.DataTable().destroy();
    };
  }, [cities, pagination.pageSize, granted]);

  return (
    <div className="bg-dark p-4 rounded mb-4">
      <div className="row mb-2">
        <CitiesFilters
          pagination={pagination}
          setPagination={setPagination}
          query={query}
          setQuery={setQuery}
          filters={filters}
          setFilters={setFilters}
          setCities={setCities}
          fetchCities={fetchCities}
          filtering={filtering}
          setFiltering={setFiltering}
        />
        <div className="col-md-2">
          {granted?.some((g) => g.type === "create") && (
            <Button
              title="Add New City"
              variant="success d-flex mt-2"
              onClick={() => {
                handleOpenAddEditModal({});
              }}
              style={{ float: "right" }}
            >
              Add New
            </Button>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-dark table-striped w-100"
        />

        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      {/* Add/Edt City Modal */}
      <AddEditCityModal
        showModal={showAddEditModal}
        setShowModal={setShowAddEditModal}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        countriesList={countries}
        fetchCities={fetchCities}
      />
      {/* City Details Modal */}
      <CityDetailsModal
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
      />
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CitiesList;
